import { render, staticRenderFns } from "./SimpleDigitalSignatureView.vue?vue&type=template&id=56dd2832&scoped=true&"
import script from "./SimpleDigitalSignatureView.vue?vue&type=script&lang=js&"
export * from "./SimpleDigitalSignatureView.vue?vue&type=script&lang=js&"
import style0 from "./SimpleDigitalSignatureView.vue?vue&type=style&index=0&id=56dd2832&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56dd2832",
  null
  
)

export default component.exports